/**
 * Builds a Shopify checkout URL that forwards the current page's query params
 * and sets utm_source to the product page pathname (existing shop attribution).
 */
export function buildShopifyCheckoutUrl(
  checkoutUrl: string,
  location: Pick<Location, 'pathname' | 'search'> = window.location
): string {
  const url = new URL(checkoutUrl);
  const pageParams = new URLSearchParams(location.search);

  pageParams.forEach((value, key) => {
    // utm_source is reserved for the product pathname attribution below
    if (key === 'utm_source') return;
    url.searchParams.append(key, value);
  });

  url.searchParams.set('utm_source', location.pathname);

  return url.toString();
}
